// @todo Move out from formatting
// use with UTC date from server
export default (isoDateString: string) => {
    return Date.parse(isoDateString.replace(new RegExp('-', 'g'), '/') + ' UTC');
};
